import {Pipe, PipeTransform} from "@angular/core";
import Helpers from "src/shared/helpers";
@Pipe({
    name: "case",
    standalone: false
})
export class CasePipe implements PipeTransform {
    constructor() { }
    transform(value: string, ...args: string[]): string {
        const caseType: string = args[0];

        switch (caseType) {
            case 'snake':
                value = Helpers.toSnakeCase(value);
                break;
            case 'lower':
                value = value.toLocaleLowerCase();
                break;
            case 'lowerFirst':
                value = Helpers.toLowerCaseFirst(value);
                break;
            case 'upper':
                value = value.toLocaleUpperCase();
                break;
            case 'upperFirst':
                value = Helpers.toUpperCaseFirst(value);
                break;
        }

        return value;
    }
}